export function setCookie(
  name: string,
  value: object,
  expiresAt: number = 2,
): void {
  const expires = new Date(expiresAt).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(JSON.stringify(value))}; expires=${expires}; path=/`;
}

export function getCookie<T = any>(name: string): T | null {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let c of ca) {
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      const rawValue = c.substring(nameEQ.length, c.length);

      try {
        return JSON.parse(decodeURIComponent(rawValue));
      } catch (e) {
        return null;
      }
    }
  }
  return null;
}
